import { render } from "./DEVOPS.vue?vue&type=template&id=136967fc"
import script from "./DEVOPS.vue?vue&type=script&lang=js"
export * from "./DEVOPS.vue?vue&type=script&lang=js"
script.render = render

export default script